import React, { useEffect } from 'react';
import Seo from '../components/Seo';
import Link from '../components/Link';
import BlogComponentList from '../components/BlogComponentList';
import BlogSources from '../components/BlogSources';
import BlogLatestPosts from '../components/BlogLatestPosts';
import RelatedBlogPosts from '../components/RelatedBlogPosts';
import BlogShare from '../components/BlogShare';
import HeroBlog from '../components/HeroBlog';
import GNX3Script from '../components/GNX3Script';
import GNX2Script from '../components/GNX2Script';

export default ({pageContext, location}) => {
	const {seo = {}, postDate, slug, author = {}, category = {}, components = [], sources = [], relatedBlogPosts = [], blogLatestPosts = [], hideFromSearchEngine} = pageContext;
	const heroBlogObject = components.find(obj => obj._type === 'heroBlog');
	const metaTitle = seo.metaTitle || `${pageContext.title} - Genexa`;
	const openGraphTitle =
		seo.openGraphTitle || `${pageContext.title} - Genexa`;
	const twitterTitle = seo.twitterTitle || `${pageContext.title} - Genexa`;
	const domain = `${location.protocol}//${location.hostname}`;
	const canonicalUrl = `${domain}/blog/${slug}`;
	const inBlogAdsList = pageContext.inBlogAds;

	const updateProgressBar = () => {
		// Get the height of the <header> tag dynamically
		const header = document.querySelector('header');
		const headerHeight = header ? header.offsetHeight : 0; // Default to 0 if no header is found

		// Update the progress bar's top position
		const progressContainer = document.getElementById('progress-container');
		progressContainer.style.top = `${headerHeight}px`; // Adjust progress bar position based on header height

		// Calculate the scroll percentage
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		const scrollPercentage = (scrollTop / scrollHeight) * 100;

		// Update the progress bar width
		const progressBar = document.getElementById('progress-bar');
		if (progressBar) {
			progressBar.style.width = `${scrollPercentage}%`;
		}
	}

	useEffect(() => {
					// The first script logic (for scroll tracking and progress bar)
			let doDomCheckGNX1;
			const domCheckGNX1 = function() {
				let checkerGNX1 = document.querySelector("header.header");
				if (checkerGNX1 !== null) {
					clearInterval(doDomCheckGNX1);

					const progressBar = document.getElementById("progress-bar");

					updateProgressBar();
					window.addEventListener("scroll", updateProgressBar);
				}
			};

			doDomCheckGNX1 = setInterval(domCheckGNX1, 200);

			// Wait for the element to exist in DOM before performing actions
			function waitForElm(selector) {
				return new Promise(resolve => {
					if (document.querySelector(selector)) {
						return resolve(document.querySelector(selector));
					}

					const observer = new MutationObserver((mutations, obs) => {
						if (document.querySelector(selector)) {
							obs.disconnect();
							resolve(document.querySelector(selector));
						}
					});

					observer.observe(document.body, {
						childList: true,
						subtree: true
					});
				});
			}

			// Scroll depth tracking
			function trackScrollDepth() {
				const depthTriggers = [20, 40, 60, 80, 100];
				let trackedDepths = new Set();

				function checkScroll() {
					const scrollPosition = window.scrollY + window.innerHeight;
					const pageHeight = document.documentElement.scrollHeight;
					const scrollPercentage = Math.round((scrollPosition / pageHeight) * 100);

					depthTriggers.forEach((depth) => {
						if (scrollPercentage >= depth && !trackedDepths.has(depth)) {
							trackedDepths.add(depth);
							window.dataLayer.push({
								event: "GA4event",
								"ga4-event-name": 'cro_event',
								"ga4-event-p1-name": 'event_category',
								"ga4-event-p1-value": 'GNX1_ScrollDepth',
								"ga4-event-p2-name": 'event_label',
								"ga4-event-p2-value": depth,
							});
						}
					});
				}

				window.addEventListener("scroll", checkScroll);
			}

			// Blog page visit tracking
			function trackBlogPageVisit() {
				if (window.location.pathname.includes("/blog")) {
					window.dataLayer.push({
						event: "GA4event",
						"ga4-event-name": 'cro_event',
						"ga4-event-p1-name": 'event_category',
						"ga4-event-p1-value": 'GNX1_TestFired',
						"ga4-event-p2-name": 'event_label',
						"ga4-event-p2-value": 'Blog Page Visit',
					});
				}
			}

			waitForElm("header").then(() => {
				trackScrollDepth();
				trackBlogPageVisit();
			});

			// Additional DOM logic for handling table of contents and anchor links
			(function() {
				console.log("GNX1 - V3");
				let doDomCheckGNX1;
				const domCheckGNX1 = function() {
					let checkerGNX1 = document.querySelector("#maincontent ");
					if (checkerGNX1 !== null) {
						clearInterval(doDomCheckGNX1);

						const ulContainer = document.querySelector('.table-content .table-content-inner ul');
						const contentContainers = document.querySelectorAll('.rich-text.rich-text--blog');

						if (!ulContainer || contentContainers.length === 0) {
							return;
						  }

						ulContainer.innerHTML = ''; // Clear existing contents

						// Check if there are any <h2> elements
						// const h2Elements = contentContainer.querySelectorAll('h2:not(.gnx-3-main-title)');

						// // Check if there are any <h3> elements
						// const h3Elements = contentContainer.querySelectorAll('h3:not(.gnx-3-main-title)');
						// let elements;

						// if (h2Elements.length > 0) {
						// 	elements = h2Elements; // Use <h2> elements if they exist
						// } else {
						// 	elements = contentContainer.querySelectorAll('p > strong, h2'); // Include <p > strong> if no <h2>
						// }

						// Select elements
						// const h2Elements = contentContainer.querySelectorAll('h2:not(.gnx-3-main-title)');
						// const h3Elements = contentContainer.querySelectorAll('h3:not(.gnx-3-main-title):not(.headline)');
						// const strongElements = contentContainer.querySelectorAll('p > strong');
						
						// // Combine all elements into a single array
						// let elements = [...h2Elements, ...h3Elements, ...strongElements];
						let elements = [];

						contentContainers.forEach(container => {
						const h2Elements = container.querySelectorAll('h2:not(.gnx-3-main-title)');
						const h3Elements = container.querySelectorAll('h3:not(.gnx-3-main-title):not(.headline)');
						const strongElements = container.querySelectorAll('p > strong');

						elements.push(...h2Elements, ...h3Elements, ...strongElements);
						});

						if (elements.length === 0) {
							return;
						}

						elements.forEach((element, index) => {
							let scrollTarget = element.getAttribute('id');

							if (!scrollTarget) {
								scrollTarget = `section-${index}`;
								element.setAttribute('id', scrollTarget);
							}

							const li = document.createElement('li');
							const a = document.createElement('a');
							a.href = `#${scrollTarget}`;
							a.textContent = element.textContent.trim();

							li.appendChild(a);
							ulContainer.appendChild(li);
						});

						// Smooth scrolling behavior
						ulContainer.addEventListener('click', function(e) {
							if (e.target && e.target.tagName === 'A') {
								e.preventDefault();
								const targetId = e.target.getAttribute('href').slice(1);
								const targetElement = document.getElementById(targetId);

								if (targetElement) {
									const header = document.querySelector('.header.header');
									const headerHeight = header ? header.offsetHeight + 10 : 100;

									const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

									window.scrollTo({
										top: targetPosition,
										behavior: 'smooth',
									});
								}
							}
						});
					}
				};

				doDomCheckGNX1 = setInterval(domCheckGNX1, 200);
			})();

			// Event tracking on table of contents clicks
			(function() {
				waitForElm("div.table-content > div.table-content-inner > ul li > a").then((elm) => {
					let buttons = document.querySelectorAll("div.table-content > div.table-content-inner > ul li > a");
					buttons.forEach(button => {
						button.addEventListener("click", (e) => {
							let buttonText = button.innerText;
							window.dataLayer.push({
								event: "GA4event",
								"ga4-event-name": 'cro_event',
								"ga4-event-p1-name": 'event_category',
								"ga4-event-p1-value": 'GNX1_TableContentClick',
								"ga4-event-p2-name": 'event_label',
								"ga4-event-p2-value": buttonText,
							});
						});
					});
				});
			})();

			// Cleanup function to remove the event listener when the component unmounts
			return () => {
				clearInterval(doDomCheckGNX1);
				window.removeEventListener("scroll", updateProgressBar);
				window.removeEventListener("scroll", trackScrollDepth);
			};

		
	  }, [pageContext, location]);
	return (
		<React.Fragment>
			<Seo
				metaTitle={metaTitle}
				metaDescription={seo.metaDescription}
				metaKeywords={seo.metaKeywords}
				openGraphTitle={openGraphTitle}
				openGraphDescription={seo.openGraphDescription}
				openGraphImage={seo.openGraphImage}
				twitterTitle={twitterTitle}
				twitterDescription={seo.twitterDescription}
				twitterImage={seo.twitterImage}
				pathname={location.pathname}
				noIndexNoFollow={hideFromSearchEngine}
				canonicalUrl={canonicalUrl}
			/>
			<HeroBlog BlogDesktopImage={pageContext.desktopBlogImage} BlogMobileImage={pageContext.mobileBlogImage} title={heroBlogObject.title} />

			{/* partial:index.partial.html */}
			<div id="progress-container">
				<div id="progress-bar">&nbsp;</div>
			</div>
			{/* partial */}
			<div className='grid-container contained mobile-pad-0'>
				<div className='row gutter--large--lg align--center side-marg-0'>
					<div className="col c9--xl mobile-pad-0">
						<div className='row gutter--large--lg align--center mobile-margin-0'>
							<div className="col c9--lg">
								<div className='contained postContent mobilePost-style'>
									<BlogComponentList author={author} category={category} title={heroBlogObject.title} subtitle={heroBlogObject.subtitle} components={components} date={postDate} />
								</div>
								<div className='best-product'></div>
							</div>
							<GNX2Script  inBlogAdsList={inBlogAdsList} />
							<GNX3Script />
							<RelatedBlogPosts posts={relatedBlogPosts} />
						</div>
					</div>
				</div>
			</div>
			</React.Fragment>
		
	);
};
